import "../style.scss";
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase/firebase";
import logo from "../img/logo.png";

const boxStyle = {
  backgroundColor: "#f9f9f9",
  padding: "25px",
  borderRadius: "8px",
  marginBottom: "30px",
};

const sectionTitle = {
  color: "#7a3260",
  fontSize: "1.3rem",
  margin: "0 0 15px 0",
  fontWeight: 500,
};

const paragraph = {
  lineHeight: 1.8,
  color: "#444",
  margin: "0 0 15px 0",
};

const list = {
  lineHeight: 1.8,
  color: "#444",
  margin: "0 0 15px 0",
  paddingLeft: "20px",
};

const linkStyle = { color: "#7a3260" };

const SUPPORT_EMAIL = "elev8ionhelp@gmail.com";
const REQUEST_NAME = "Kontolöschung";
const MAIL_SUBJECT = "Kontolöschung anfordern";

function buildContactMessage(email, note) {
  const lines = [
    `Kontolöschung angefordert für die E-Mail-Adresse ${email}.`,
  ];
  if (note) {
    lines.push("", "Nachricht:", note);
  }
  return lines.join("\n");
}

function buildMailText(email, note) {
  const lines = [
    "Über das Web-Portal wurde eine Kontolöschung angefordert.",
    "",
    `E-Mail-Adresse des Kontos: ${email}`,
  ];
  if (note) {
    lines.push("", "Nachricht:", note);
  }
  lines.push(
    "",
    "Die Anfrage geht an den Support. Die Löschung erfolgt nach Prüfung der Anfrage."
  );
  return lines.join("\n");
}

export default function AccountDeletion() {
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState({
    success: false,
    message: "",
  });

  useEffect(() => {
    const openIcon = document.querySelector(".fa-bars");
    const closeIcon = document.querySelector(".close-nav");
    const mobileBG = document.querySelector(".mobile-bg");
    const mobileNav = document.querySelector(".mobile-nav");
    const navItem = document.querySelector(".nav-item");

    const handleMenuToggle = () => {
      if (mobileBG && mobileNav && openIcon) {
        mobileBG.classList.toggle("display-none");
        mobileNav.classList.remove("slide-out");
        mobileNav.classList.toggle("slide-in");
        openIcon.classList.toggle("display-none");
      }
    };

    const handleCloseMenu = () => {
      if (mobileBG && mobileNav && openIcon) {
        mobileNav.classList.remove("slide-in");
        mobileNav.classList.add("slide-out");

        setTimeout(() => {
          mobileBG.classList.add("display-none");
          openIcon.classList.remove("display-none");
        }, 500);
      }
    };

    if (openIcon) openIcon.addEventListener("click", handleMenuToggle);
    if (closeIcon) closeIcon.addEventListener("click", handleCloseMenu);
    if (navItem) navItem.addEventListener("click", handleCloseMenu);

    return () => {
      if (openIcon) openIcon.removeEventListener("click", handleMenuToggle);
      if (closeIcon) closeIcon.removeEventListener("click", handleCloseMenu);
      if (navItem) navItem.removeEventListener("click", handleCloseMenu);
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const accountEmail = email.trim();
    const wishText = note.trim();

    if (
      accountEmail.length < 3 ||
      accountEmail.length > 120 ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(accountEmail)
    ) {
      setFormStatus({
        success: false,
        message:
          "Bitte geben Sie die E-Mail-Adresse des Kontos an (3 bis 120 Zeichen).",
      });
      return;
    }

    const contactMessage = buildContactMessage(accountEmail, wishText);
    const mailText = buildMailText(accountEmail, wishText);

    if (
      contactMessage.length < 1 ||
      contactMessage.length > 4000 ||
      mailText.length < 1 ||
      mailText.length > 8000 ||
      MAIL_SUBJECT.length < 1 ||
      MAIL_SUBJECT.length > 150
    ) {
      setFormStatus({
        success: false,
        message:
          "Die Nachricht ist zu lang. Bitte kürzen Sie den Text und senden Sie das Formular erneut.",
      });
      return;
    }

    setIsSubmitting(true);
    setFormStatus({ success: false, message: "" });

    try {
      await addDoc(collection(db, "contactMessages"), {
        name: REQUEST_NAME,
        email: accountEmail,
        message: contactMessage,
      });

      await addDoc(collection(db, "mail"), {
        to: SUPPORT_EMAIL,
        message: {
          subject: MAIL_SUBJECT,
          text: mailText,
        },
      });

      setEmail("");
      setNote("");
      setFormStatus({
        success: true,
        message:
          "Ihre Anfrage wurde gesendet und geht an den Support. Die Löschung erfolgt nach Prüfung der Anfrage.",
      });
    } catch (error) {
      console.error("Kontolöschung konnte nicht gesendet werden:", error);
      setFormStatus({
        success: false,
        message:
          "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="mobile-bg display-none">
        <ul className="mobile-nav">
          <li
            className="nav-item"
            style={{ padding: "15px 20px", marginTop: "70px" }}
          >
            <a
              href="/"
              style={{
                color: "#fff",
                textDecoration: "none",
                fontSize: "18px",
                display: "block",
                fontWeight: "500",
              }}
            >
              Zurück
            </a>
          </li>
        </ul>
        <div
          className="close-nav"
          style={{
            backgroundColor: "transparent",
            width: "100%",
            height: "100%",
          }}
        ></div>
      </div>

      <header style={{ top: "0px" }} className="scrolled">
        <nav className="container">
          <a href="/" className="logo-link">
            <img src={logo} alt="" className="logo-img" />
          </a>

          <i
            style={{ paddingRight: "20px", color: "#7a3260" }}
            className="fas fa-bars"
          >
            <FontAwesomeIcon
              style={{ color: "#7a3260", cursor: "pointer" }}
              icon={icon({ name: "bars", style: "solid" })}
            />
          </i>
          <ul>
            <li>
              <a href="/" className="nav-link">
                Zurück
              </a>
            </li>
          </ul>
        </nav>
      </header>

      <div
        className="container"
        style={{ padding: "100px 50px", paddingBottom: "50px" }}
      >
        <h1
          style={{
            color: "#7a3260",
            textAlign: "left",
            padding: "20px 0",
            fontSize: "2.2rem",
            fontWeight: 600,
            marginBottom: "30px",
            borderBottom: "2px solid #f0f0f0",
          }}
        >
          Konto löschen
        </h1>

        <p style={paragraph}>
          Sie können Ihr Elev8ion-Konto hier oder direkt in der App löschen.
        </p>

        <div style={boxStyle}>
          <h2 style={sectionTitle}>Sofort in der App löschen</h2>
          <ol style={list}>
            <li>Öffnen Sie die Elev8ion-App.</li>
            <li>Öffnen Sie die Einstellungen und wählen Sie die Kontolöschung.</li>
            <li>Bestätigen Sie die Löschung in der App.</li>
          </ol>
        </div>

        <div style={boxStyle}>
          <h2 style={sectionTitle}>Löschung per Formular anfordern</h2>
          <p style={paragraph}>
            Wenn Sie die App nicht nutzen können, fordern Sie die Löschung hier
            an. Die Anfrage geht an den Support. Die Löschung erfolgt nach
            Prüfung der Anfrage.
          </p>

          <section className="contact-us" style={{ padding: 0, background: "transparent" }}>
            <form className="contact-form" onSubmit={handleSubmit}>
              {formStatus.message && (
                <div
                  className={`form-message ${
                    formStatus.success ? "success" : "error"
                  }`}
                  style={{
                    padding: "10px",
                    borderRadius: "5px",
                    marginBottom: "15px",
                    textAlign: "center",
                    backgroundColor: formStatus.success
                      ? "rgba(75, 181, 67, 0.2)"
                      : "rgba(255, 0, 0, 0.1)",
                    color: formStatus.success ? "#2f7d32" : "#c62828",
                  }}
                >
                  {formStatus.message}
                </div>
              )}

              <div className="form-group">
                <label htmlFor="account-email" style={{ ...paragraph, fontWeight: 600 }}>
                  E-Mail-Adresse des Kontos
                </label>
                <input
                  id="account-email"
                  type="email"
                  className="form-input"
                  placeholder="name@beispiel.at"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  minLength={3}
                  maxLength={120}
                  autoComplete="email"
                />
              </div>

              <div className="form-group">
                <label htmlFor="account-note" style={{ ...paragraph, fontWeight: 600 }}>
                  Nachricht (optional)
                </label>
                <textarea
                  id="account-note"
                  className="form-input textarea"
                  placeholder="Optionaler Hinweis an den Support"
                  rows={4}
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  maxLength={3500}
                />
              </div>

              <button
                className="btn submit-form"
                type="submit"
                disabled={isSubmitting}
                style={{
                  opacity: isSubmitting ? 0.7 : 1,
                  cursor: isSubmitting ? "wait" : "pointer",
                }}
              >
                {isSubmitting ? "Wird gesendet..." : "Löschung anfordern"}
              </button>
            </form>
          </section>
        </div>

        <div style={boxStyle}>
          <h2 style={sectionTitle}>Welche Daten gelöscht werden</h2>
          <ul style={list}>
            <li>Konto und Anmeldedaten</li>
            <li>Trainings- und Verlaufsdaten</li>
            <li>hochgeladenes Profilbild</li>
          </ul>
          <p style={{ ...paragraph, margin: 0 }}>
            Die Löschung erfolgt nach Prüfung der Anfrage.
          </p>
        </div>

        <div style={boxStyle}>
          <h2 style={sectionTitle}>Datenschutzerklärung</h2>
          <p style={{ ...paragraph, margin: 0 }}>
            Weitere Informationen zum Umgang mit Ihren Daten finden Sie in der{" "}
            <a href="/impressum" style={linkStyle}>
              Datenschutzerklärung
            </a>
            .
          </p>
        </div>
      </div>

      <footer>
        <div className="container">
          <ul className="flex-row">
            <li>
              <a href="/">Zurück</a>
            </li>
          </ul>
          <ul className="flex-row">
            <li>
              <a
                href="https://play.google.com/store/apps/details?id=com.trainingsapp.trainingsapp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-google-play">
                  <FontAwesomeIcon
                    icon={icon({ name: "google-play", style: "brands" })}
                  />
                </i>
              </a>
            </li>
            <li>
              <a
                href="https://apps.apple.com/at/app/elev8ion/id1645771356"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-app-store-ios">
                  <FontAwesomeIcon
                    icon={icon({ name: "app-store-ios", style: "brands" })}
                  />
                </i>
              </a>
            </li>
          </ul>
          <p>{"© 2025 ELEV8ION"}</p>
        </div>
      </footer>
    </>
  );
}
